import { useState } from "react";
import { apiClient } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Target } from "lucide-react";

export default function TrackerCard({ facility, prisoner }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const targetType = prisoner ? "prisoner" : "facility";
  const targetId = prisoner?.id || facility?.id;
  const targetLabel = prisoner
    ? `${prisoner.first_name} ${prisoner.last_name} (ID ${prisoner.inmate_id})`
    : facility?.name;

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !targetId) return;
    setSubmitting(true);
    try {
      const { data } = await apiClient.post("/tracker/checkout", {
        email,
        target_type: targetType,
        target_id: targetId,
        target_label: targetLabel,
        origin_url: window.location.origin,
      });
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        toast.error("Could not create checkout session");
      }
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not start checkout");
      setSubmitting(false);
    }
  };

  return (
    <Card className="p-5 border-2 border-amber-200 bg-amber-50" data-testid="tracker-card">
      <div className="flex items-center gap-2">
        <div className="grid h-9 w-9 place-items-center rounded-md bg-amber-500 text-white">
          <Target size={16} />
        </div>
        <div>
          <h3 className="font-heading text-base font-bold text-slate-900">
            Track this {targetType} — $2 / month
          </h3>
          <p className="text-xs text-slate-700">
            Instant email alerts on status changes {prisoner ? "and facility transfers" : ""}. Cancel anytime.
          </p>
        </div>
      </div>
      <form onSubmit={submit} className="mt-4 space-y-2">
        <Input
          data-testid="tracker-email-input"
          type="email"
          required
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-white"
        />
        <Button
          data-testid="tracker-checkout-btn"
          type="submit"
          disabled={submitting}
          className="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold"
        >
          {submitting ? "Opening secure checkout…" : "Subscribe for $2/month"}
        </Button>
      </form>
      <p className="mt-2 text-[11px] text-slate-500">
        Payments by Stripe · Test card: 4242 4242 4242 4242 · Any future expiry & CVC
      </p>
    </Card>
  );
}
